// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.small-active-chip {
  height: 26px;
  margin: 0px;
}
.small-active-chip ion-icon {
  font-size: 18px;
}

/* When in Auto Mode - Grayed out but visible */
.small-locked-chip {
  height: 26px;
  opacity: 0.7;
  pointer-events: none; /* Prevents clicking when in Auto */
  background: #f4f4f4;
  /* Ensure X is hidden in Auto */
}
.small-locked-chip ion-icon {
  display: none;
}

.gray-text {
  color: #999;
  font-size: 12px;
}

.route::part(container) {
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/app/flight-planning/route-plan/alternate/alternate.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,WAAA;AACJ;AAAI;EACI,eAAA;AAER;;AACA,+CAAA;AACA;EACE,YAAA;EACA,YAAA;EACA,oBAAA,EAAA,mCAAA;EACA,mBAAA;EAC4B,+BAAA;AAE9B;AAFE;EAAW,aAAA;AAKb;;AAFA;EACE,WAAA;EACA,eAAA;AAKF;;AADE;EACE,cAAA;AAIJ","sourcesContent":[".small-active-chip {\n    height: 26px;\n    margin: 0px;\n    ion-icon {\n        font-size: 18px;\n    }\n}\n/* When in Auto Mode - Grayed out but visible */\n.small-locked-chip {\n  height: 26px;\n  opacity: 0.7;\n  pointer-events: none; /* Prevents clicking when in Auto */\n  background: #f4f4f4;\n  ion-icon { display: none; } /* Ensure X is hidden in Auto */\n}\n\n.gray-text {\n  color: #999;\n  font-size: 12px;\n}\n\n.route {\n  &::part(container) {\n    display: block;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
